import {app} from './config.js'

// 登录
export  function login(data) {
  let url = app.login
  return axios({method: 'post',url:url, data:data})
}

// 退出登录
export function logout(data) {
  let url = app.logout
  return axios({method: 'post',url:url,data:data})
}

export function getUserInfo() {
  let url = app.getUserinfo
  return axios({method:'get', url:url})
}